'use client';

import {capabilitiesContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function CapabilitiesSection() {
  return (
    <section id={capabilitiesContent.id} aria-labelledby="capabilities-heading" className={`${sectionPadding} bg-kobra-bg ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <SectionHeader
            badge="Producto"
            title={capabilitiesContent.title}
            description={capabilitiesContent.description}
          />
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {capabilitiesContent.pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <FadeIn key={pillar.id} delay={index * 0.1} className="h-full">
                <article className={`h-full bg-white border border-kobra-border rounded-2xl p-6 lg:p-8 hover:border-kobra-accent/40 ${cardHoverClass}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-kobra-accent-soft rounded-lg flex items-center justify-center text-kobra-accent">
                      <Icon className="w-5 h-5" aria-hidden="true" />
                    </div>
                    <h3 className="text-xl font-bold text-kobra-text-dark">{pillar.title}</h3>
                  </div>
                  <p className="text-kobra-text-muted text-sm leading-relaxed mb-5">{pillar.description}</p>
                  <ul className="flex flex-wrap gap-2">
                    {pillar.capabilities.map((cap) => (
                      <li
                        key={cap}
                        className="text-xs font-medium text-kobra-text-dark bg-white border border-kobra-border px-3 py-1.5 rounded-full"
                      >
                        {cap}
                      </li>
                    ))}
                  </ul>
                </article>
              </FadeIn>
            );
          })}
        </div>
      </SectionContainer>
    </section>
  );
}
